// src/utils/nativeStatusBar.js

import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";

export async function setupNativeStatusBar() {
  if (!Capacitor.isNativePlatform()) return;

  try {
    document.documentElement.style.backgroundColor = "#0F49BC";
    document.body.style.backgroundColor = "#0F49BC";

    await StatusBar.show();
    await StatusBar.setOverlaysWebView({ overlay: true });

    // Style.Dark = light/white icons for a dark background.
    await StatusBar.setStyle({ style: Style.Dark });
  } catch (err) {
    console.warn("StatusBar setup failed:", err);
  }
}
